// import { canAccess } from '@/acl/roles';

const menuItems = [
  {
    url: '/',
    name: 'DataCentreReports',
    slug: 'dashboard',
    tagColor: 'warning',
    iconType: 'far',
    icon: 'database',
    class: '',
  },
  {
    url: process.env.VUE_APP_LANDING_PAGE_URL,
    name: 'ReturnToFides',
    slug: 'external',
    i18n: 'ReturnToFides',
    tagColor: 'warning',
    iconType: 'fas',
    icon: 'arrow-alt-left',
    class: 'return-to-fides mb-4',
  },
];

// const canAccessMenuItem = async (item) => {
//   return await canAccess(item);
// }

export const getMenuItems = async () => {
  // const filteredMenuItems = [];

  // for (const menuItem of menuItems) {
  //   if (await canAccessMenuItem(menuItem)) {
  //     filteredMenuItems.push(menuItem);
  //   }
  // }

  return menuItems;
};
